import React from 'react';

// 1. Analytics SVG with animated data flow and charts
export const AnalyticsSVG = ({ className }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 240 240"
            className={className}
        >
            {/* Background with grid for analytics canvas */}
            <defs>
                <pattern id="analyticsGrid" width="20" height="20" patternUnits="userSpaceOnUse">
                    <path d="M 20 0 L 0 0 0 20" fill="none" stroke="#3B82F6" strokeWidth="0.5" strokeOpacity="0.1" />
                </pattern>
                <linearGradient id="analyticsGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#2563EB" stopOpacity="0.1" />
                    <stop offset="100%" stopColor="#60A5FA" stopOpacity="0.2" />
                </linearGradient>
            </defs>
            <rect width="240" height="240" fill="url(#analyticsGrid)" />
            <rect x="20" y="20" width="200" height="200" rx="10" fill="url(#analyticsGradient)" />

            {/* Main Analytics Dashboard */}
            <rect x="40" y="40" width="160" height="100" rx="5" fill="#0F172A" stroke="#3B82F6" strokeWidth="2" />

            {/* Dashboard Header */}
            <rect x="40" y="40" width="160" height="20" rx="5" fill="#1E3A8A" />
            <circle cx="50" cy="50" r="3" fill="#EF4444" />
            <circle cx="60" cy="50" r="3" fill="#F59E0B" />
            <circle cx="70" cy="50" r="3" fill="#10B981" />
            <text x="110" y="53" fontSize="10" fontFamily="Arial" textAnchor="middle" fill="#FFFFFF">Analytics Dashboard</text>

            {/* Line Chart */}
            <rect x="50" y="70" width="70" height="60" rx="2" fill="#1E293B" />
            <text x="85" y="80" fontSize="6" fontFamily="Arial" textAnchor="middle" fill="#FFFFFF">Revenue Trends</text>

            <polyline
                points="55,110 60,105 65,115 70,95 75,100 80,90 85,105 90,85 95,95 100,90 105,80 110,85"
                stroke="#3B82F6"
                strokeWidth="1.5"
                fill="none"
                strokeLinejoin="round"
                strokeLinecap="round"
            >
                <animate attributeName="stroke-dasharray" from="0,500" to="500,0" dur="3s" repeatCount="1" />
            </polyline>

            {/* Animated data point */}
            <circle cx="110" cy="85" r="2" fill="#60A5FA">
                <animate attributeName="r" values="2;3;2" dur="2s" repeatCount="indefinite" />
                <animate attributeName="fill-opacity" values="0.6;1;0.6" dur="2s" repeatCount="indefinite" />
            </circle>

            {/* Bar Chart */}
            <rect x="130" y="70" width="60" height="60" rx="2" fill="#1E293B" />
            <text x="160" y="80" fontSize="6" fontFamily="Arial" textAnchor="middle" fill="#FFFFFF">Sales by Region</text>

            {/* Bars with animation */}
            <rect x="140" y="110" width="6" height="10" fill="#60A5FA">
                <animate attributeName="height" from="0" to="10" dur="1s" repeatCount="1" />
                <animate attributeName="y" from="120" to="110" dur="1s" repeatCount="1" />
            </rect>
            <rect x="150" y="100" width="6" height="20" fill="#60A5FA">
                <animate attributeName="height" from="0" to="20" dur="1s" begin="0.2s" repeatCount="1" />
                <animate attributeName="y" from="120" to="100" dur="1s" begin="0.2s" repeatCount="1" />
            </rect>
            <rect x="160" y="90" width="6" height="30" fill="#60A5FA">
                <animate attributeName="height" from="0" to="30" dur="1s" begin="0.4s" repeatCount="1" />
                <animate attributeName="y" from="120" to="90" dur="1s" begin="0.4s" repeatCount="1" />
            </rect>
            <rect x="170" y="105" width="6" height="15" fill="#60A5FA">
                <animate attributeName="height" from="0" to="15" dur="1s" begin="0.6s" repeatCount="1" />
                <animate attributeName="y" from="120" to="105" dur="1s" begin="0.6s" repeatCount="1" />
            </rect>

            {/* Data Sources and Flow */}
            <rect x="40" y="160" width="40" height="20" rx="3" fill="#1E3A8A" />
            <text x="60" y="173" fontSize="6" fontFamily="Arial" textAnchor="middle" fill="#FFFFFF">CRM Data</text>

            <rect x="100" y="160" width="40" height="20" rx="3" fill="#1E3A8A" />
            <text x="120" y="173" fontSize="6" fontFamily="Arial" textAnchor="middle" fill="#FFFFFF">ERP Data</text>

            <rect x="160" y="160" width="40" height="20" rx="3" fill="#1E3A8A" />
            <text x="180" y="173" fontSize="6" fontFamily="Arial" textAnchor="middle" fill="#FFFFFF">Web Analytics</text>

            {/* Data Flow Connectors */}
            <path d="M60 160 L60 150 Q 60 145 65 145 L120 145 L120 140"
                fill="none"
                stroke="#60A5FA"
                strokeWidth="1.5"
                strokeDasharray="3,2" />

            <path d="M120 160 L120 150 Q 120 145 120 145 L120 145 L120 140"
                fill="none"
                stroke="#60A5FA"
                strokeWidth="1.5"
                strokeDasharray="3,2" />

            <path d="M180 160 L180 150 Q 180 145 175 145 L120 145 L120 140"
                fill="none"
                stroke="#60A5FA"
                strokeWidth="1.5"
                strokeDasharray="3,2" />

            {/* Animated Data Particles */}
            <circle cx="0" cy="0" r="2" fill="#93C5FD">
                <animateMotion
                    path="M60 160 L60 150 Q 60 145 65 145 L120 145 L120 140"
                    dur="2s"
                    repeatCount="indefinite" />
            </circle>

            <circle cx="0" cy="0" r="2" fill="#93C5FD">
                <animateMotion
                    path="M120 160 L120 150 Q 120 145 120 145 L120 145 L120 140"
                    dur="1.5s"
                    repeatCount="indefinite" />
            </circle>

            <circle cx="0" cy="0" r="2" fill="#93C5FD">
                <animateMotion
                    path="M180 160 L180 150 Q 180 145 175 145 L120 145 L120 140"
                    dur="2.5s"
                    repeatCount="indefinite" />
            </circle>
        </svg>
    );
};

// 2. Visualization SVG with animated charts and graphs
export const VisualizationSVG = ({ className }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 240 240"
            className={className}
        >
            {/* Background with gradient */}
            <defs>
                <linearGradient id="vizGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#059669" stopOpacity="0.1" />
                    <stop offset="100%" stopColor="#34D399" stopOpacity="0.2" />
                </linearGradient>
                <clipPath id="circleClip">
                    <circle cx="120" cy="110" r="35" />
                </clipPath>
            </defs>
            <rect width="240" height="240" fill="url(#vizGradient)" />

            {/* Central visualization hub */}
            <circle cx="120" cy="110" r="60" fill="#0F172A" stroke="#10B981" strokeWidth="2" />

            {/* Pie Chart */}
            <path d="M120 110 L120 75 A35 35 0 0 1 151 122.5 Z" fill="#10B981">
                <animate attributeName="d"
                    values="M120 110 L120 75 A35 35 0 0 1 120 75 Z;
                                M120 110 L120 75 A35 35 0 0 1 151 122.5 Z"
                    dur="2s"
                    repeatCount="1" />
            </path>
            <path d="M120 110 L151 122.5 A35 35 0 0 1 107 142 Z" fill="#34D399">
                <animate attributeName="d"
                    values="M120 110 L151 122.5 A35 35 0 0 1 151 122.5 Z;
                                M120 110 L151 122.5 A35 35 0 0 1 107 142 Z"
                    dur="2s"
                    begin="0.5s"
                    repeatCount="1" />
            </path>
            <path d="M120 110 L107 142 A35 35 0 0 1 89 97.5 Z" fill="#6EE7B7">
                <animate attributeName="d"
                    values="M120 110 L107 142 A35 35 0 0 1 107 142 Z;
                                M120 110 L107 142 A35 35 0 0 1 89 97.5 Z"
                    dur="2s"
                    begin="1s"
                    repeatCount="1" />
            </path>
            <path d="M120 110 L89 97.5 A35 35 0 0 1 120 75 Z" fill="#A7F3D0">
                <animate attributeName="d"
                    values="M120 110 L89 97.5 A35 35 0 0 1 89 97.5 Z;
                                M120 110 L89 97.5 A35 35 0 0 1 120 75 Z"
                    dur="2s"
                    begin="1.5s"
                    repeatCount="1" />
            </path>

            {/* Chart labels */}
            <circle cx="175" cy="85" r="4" fill="#10B981" />
            <text x="185" y="88" fontSize="7" fontFamily="Arial" fill="#FFFFFF">Product A</text>

            <circle cx="175" cy="100" r="4" fill="#34D399" />
            <text x="185" y="103" fontSize="7" fontFamily="Arial" fill="#FFFFFF">Product B</text>

            <circle cx="175" cy="115" r="4" fill="#6EE7B7" />
            <text x="185" y="118" fontSize="7" fontFamily="Arial" fill="#FFFFFF">Product C</text>

            <circle cx="175" cy="130" r="4" fill="#A7F3D0" />
            <text x="185" y="133" fontSize="7" fontFamily="Arial" fill="#FFFFFF">Product D</text>

            {/* Dashboard cards around the central hub */}
            {/* Card 1 - Line chart */}
            <rect x="40" y="50" width="40" height="30" rx="3" fill="#064E3B" />
            <polyline
                points="45,70 50,65 55,68 60,60 65,62 70,55 75,60"
                stroke="#10B981"
                strokeWidth="1"
                fill="none"
                strokeLinecap="round"
            >
                <animate attributeName="stroke-dasharray" from="0,100" to="100,0" dur="2s" repeatCount="1" />
            </polyline>

            {/* Card 2 - Bar chart */}
            <rect x="160" y="50" width="40" height="30" rx="3" fill="#064E3B" />
            <rect x="165" y="65" width="4" height="10" fill="#10B981">
                <animate attributeName="height" from="0" to="10" dur="1s" repeatCount="1" />
                <animate attributeName="y" from="75" to="65" dur="1s" repeatCount="1" />
            </rect>
            <rect x="175" y="60" width="4" height="15" fill="#10B981">
                <animate attributeName="height" from="0" to="15" dur="1s" begin="0.2s" repeatCount="1" />
                <animate attributeName="y" from="75" to="60" dur="1s" begin="0.2s" repeatCount="1" />
            </rect>
            <rect x="185" y="70" width="4" height="5" fill="#10B981">
                <animate attributeName="height" from="0" to="5" dur="1s" begin="0.4s" repeatCount="1" />
                <animate attributeName="y" from="75" to="70" dur="1s" begin="0.4s" repeatCount="1" />
            </rect>

            {/* Card 3 - Scatter plot */}
            <rect x="40" y="150" width="40" height="30" rx="3" fill="#064E3B" />
            <circle cx="50" cy="165" r="2" fill="#A7F3D0">
                <animate attributeName="opacity" from="0" to="1" dur="0.5s" begin="0s" repeatCount="1" />
            </circle>
            <circle cx="60" cy="170" r="2" fill="#A7F3D0">
                <animate attributeName="opacity" from="0" to="1" dur="0.5s" begin="0.2s" repeatCount="1" />
            </circle>
            <circle cx="65" cy="160" r="2" fill="#A7F3D0">
                <animate attributeName="opacity" from="0" to="1" dur="0.5s" begin="0.4s" repeatCount="1" />
            </circle>
            <circle cx="70" cy="165" r="2" fill="#A7F3D0">
                <animate attributeName="opacity" from="0" to="1" dur="0.5s" begin="0.6s" repeatCount="1" />
            </circle>
            <circle cx="75" cy="155" r="2" fill="#A7F3D0">
                <animate attributeName="opacity" from="0" to="1" dur="0.5s" begin="0.8s" repeatCount="1" />
            </circle>

            {/* Card 4 - Gauge chart */}
            <rect x="160" y="150" width="40" height="30" rx="3" fill="#064E3B" />
            <path d="M180 170 L180 160 A10 10 0 0 1 190 170"
                fill="none"
                stroke="#10B981"
                strokeWidth="2"
                strokeLinecap="round">
                <animate attributeName="d"
                    values="M180 170 L180 160 A10 10 0 0 1 180 160;
                                M180 170 L180 160 A10 10 0 0 1 190 170"
                    dur="2s"
                    repeatCount="1" />
            </path>
            <circle cx="180" cy="170" r="2" fill="#FFFFFF" />

            {/* Connectors between charts and central hub */}
            <path d="M80 65 L100 80" fill="none" stroke="#10B981" strokeWidth="1" strokeDasharray="3,2" />
            <path d="M160 65 L140 80" fill="none" stroke="#10B981" strokeWidth="1" strokeDasharray="3,2" />
            <path d="M80 165 L100 140" fill="none" stroke="#10B981" strokeWidth="1" strokeDasharray="3,2" />
            <path d="M160 165 L140 140" fill="none" stroke="#10B981" strokeWidth="1" strokeDasharray="3,2" />

            {/* Animated data flow */}
            <circle cx="0" cy="0" r="1.5" fill="#A7F3D0">
                <animateMotion path="M80 65 L100 80" dur="1.5s" repeatCount="indefinite" />
            </circle>
            <circle cx="0" cy="0" r="1.5" fill="#A7F3D0">
                <animateMotion path="M160 65 L140 80" dur="1.5s" repeatCount="indefinite" />
            </circle>
            <circle cx="0" cy="0" r="1.5" fill="#A7F3D0">
                <animateMotion path="M80 165 L100 140" dur="1.5s" repeatCount="indefinite" />
            </circle>
            <circle cx="0" cy="0" r="1.5" fill="#A7F3D0">
                <animateMotion path="M160 165 L140 140" dur="1.5s" repeatCount="indefinite" />
            </circle>
        </svg>
    );
};

// 3. Performance SVG with KPI meters and goal tracking
export const PerformanceSVG = ({ className }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 240 240"
            className={className}
        >
            {/* Background with gradient */}
            <defs>
                <linearGradient id="perfGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#4F46E5" stopOpacity="0.1" />
                    <stop offset="100%" stopColor="#818CF8" stopOpacity="0.2" />
                </linearGradient>
            </defs>
            <rect width="240" height="240" fill="url(#perfGradient)" />

            {/* Main KPI dashboard */}
            <rect x="40" y="50" width="160" height="140" rx="5" fill="#0F172A" stroke="#4F46E5" strokeWidth="2" />

            {/* Dashboard header */}
            <rect x="40" y="50" width="160" height="20" rx="5" fill="#3730A3" />
            <text x="120" y="64" fontSize="10" fontFamily="Arial" textAnchor="middle" fill="#FFFFFF">Performance Metrics</text>

            {/* KPI Scorecards */}
            {/* KPI 1 - Sales Goal */}
            <rect x="50" y="80" width="65" height="40" rx="3" fill="#1E1B4B" />
            <text x="82.5" y="95" fontSize="8" fontFamily="Arial" textAnchor="middle" fill="#FFFFFF">Sales Target</text>

            {/* Progress bar */}
            <rect x="55" y="100" width="55" height="6" rx="3" fill="#1E293B" />
            <rect x="55" y="100" width="0" height="6" rx="3" fill="#818CF8">
                <animate attributeName="width" from="0" to="44" dur="2s" repeatCount="1" />
            </rect>

            {/* Progress percentage */}
            <text x="82.5" y="115" fontSize="10" fontFamily="Arial" textAnchor="middle" fill="#FFFFFF">80%</text>

            {/* KPI 2 - Conversion Rate */}
            <rect x="125" y="80" width="65" height="40" rx="3" fill="#1E1B4B" />
            <text x="157.5" y="95" fontSize="8" fontFamily="Arial" textAnchor="middle" fill="#FFFFFF">Conversion Rate</text>

            {/* Circular progress */}
            <circle cx="157.5" cy="108" r="10" fill="none" stroke="#1E293B" strokeWidth="3" />
            <path d="M157.5 98 A10 10 0 0 1 167.5 108 A10 10 0 0 1 157.5 118 A10 10 0 0 1 147.5 108 A10 10 0 0 1 157.5 98"
                fill="none"
                stroke="#818CF8"
                strokeWidth="3"
                strokeDasharray="62.8, 62.8"
                strokeDashoffset="62.8">
                <animate attributeName="stroke-dashoffset" from="62.8" to="15.7" dur="2s" repeatCount="1" />
            </path>
            <text x="157.5" y="111" fontSize="7" fontFamily="Arial" textAnchor="middle" fill="#FFFFFF">75%</text>

            {/* KPI 3 - Customer Satisfaction */}
            <rect x="50" y="130" width="65" height="40" rx="3" fill="#1E1B4B" />
            <text x="82.5" y="145" fontSize="8" fontFamily="Arial" textAnchor="middle" fill="#FFFFFF">CSAT Score</text>

            {/* Star rating */}
            <polygon points="70,155 72.5,150 75,155 80,156 76,160 77,165 72.5,163 68,165 69,160 65,156" fill="#818CF8" />
            <polygon points="82.5,155 85,150 87.5,155 92.5,156 88.5,160 89.5,165 85,163 80.5,165 81.5,160 77.5,156" fill="#818CF8" />
            <polygon points="95,155 97.5,150 100,155 105,156 101,160 102,165 97.5,163 93,165 94,160 90,156" fill="#818CF8" opacity="0.5">
                <animate attributeName="opacity" from="0.5" to="1" dur="1s" begin="1s" repeatCount="1" />
            </polygon>
            <polygon points="107.5,155 110,150 112.5,155 117.5,156 113.5,160 114.5,165 110,163 105.5,165 106.5,160 102.5,156" fill="#818CF8" opacity="0.3">
                <animate attributeName="opacity" from="0.3" to="0.3" dur="1s" begin="1s" repeatCount="1" />
            </polygon>

            {/* KPI 4 - Cost Efficiency */}
            <rect x="125" y="130" width="65" height="40" rx="3" fill="#1E1B4B" />
            <text x="157.5" y="145" fontSize="8" fontFamily="Arial" textAnchor="middle" fill="#FFFFFF">Cost Efficiency</text>

            {/* Gauge chart */}
            <path d="M157.5 170 L157.5 158 A12 12 0 0 1 168 165"
                fill="none"
                stroke="#4F46E5"
                strokeWidth="2.5"
                strokeLinecap="round">
                <animate attributeName="d"
                    values="M157.5 170 L157.5 158 A12 12 0 0 1 157.5 158;
                                M157.5 170 L157.5 158 A12 12 0 0 1 168 165"
                    dur="2s"
                    repeatCount="1" />
            </path>
            <path d="M142,165 A16,16 0 0,1 173,165" fill="none" stroke="#1E293B" strokeWidth="1" />
            <text x="157.5" y="170" fontSize="7" fontFamily="Arial" textAnchor="middle" fill="#FFFFFF">85%</text>

            {/* Target icon at top */}
            <circle cx="120" cy="25" r="15" fill="#0F172A" stroke="#4F46E5" strokeWidth="1.5" />
            <circle cx="120" cy="25" r="10" fill="none" stroke="#818CF8" strokeWidth="1" />
            <circle cx="120" cy="25" r="5" fill="none" stroke="#818CF8" strokeWidth="1" />
            <circle cx="120" cy="25" r="2" fill="#818CF8" />

            {/* Connecting lines and animated data flow */}
            <path d="M120 40 L120 50" fill="none" stroke="#4F46E5" strokeWidth="1.5" strokeDasharray="3,2" />

            <circle cx="0" cy="0" r="1.5" fill="#A5B4FC">
                <animateMotion path="M120 40 L120 50" dur="1s" repeatCount="indefinite" />
            </circle>
        </svg>
    );
};